import { init, id } from "@instantdb/react";

const APP_ID = "3587dea3-4307-414e-a952-27835c8def5c";

export const db = init({ appId: APP_ID });
export { id };

// Schema namespaces used across the app:
// products, orders, orderItems, users, reviews, coupons, banners, settings, categories
